// @TODO: <HEALTH2019>
(function () {
    App.controller('ZochUploadCtrl', ZochUploadCtrl);
    ZochUploadCtrl.$inject = ['$scope', 'ZochaFileSharingService', '$mdDialog', 'Config', 'FileSaver'];

    function ZochUploadCtrl($scope, ZochaFileSharingService, $mdDialog, Config, FileSaver) {
        var self = this;
        self.uploadList = [];
        self.uploading = false;
        self.formats = 'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv, image/jpeg, image/png, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        self.currentPage = 0;
        self.numberOfPages = 1;
        self.downloadBusy = false;

        initPage();

        self.uploadFile = function (files) {
            self.uploading = true;
            var file = files[0];

            ZochaFileSharingService.uploadFile(file)
                .then(function() {
                }, function () {
                    showPopUp(null, 'Wystąpił błąd',
                        'Nie udało się przesłać wybranego pliku');
                })
                .finally(function () {
                    self.uploading = false;
                    self.currentPage = 0;
                    self.numberOfPages = 1;
                    fetchUploadedFilesList(self.currentPage);
                });
        };

        self.uploadError = function (error) {
            switch(error) {
                case 'FILE_IS_TOO_BIG':
                    showPopUp(null, 'Wystąpił błąd',
                        'Wybrany plik jest zbyt duży. Maksymalny rozmiar pliku: 3MB');
                    break;
                case 'FILE_WRONG_FORMAT':
                    showPopUp(null, 'Wystąpił błąd',
                        'Wybrano plik niewłaściwego formatu. Dostępne rozszerzenia pliku: pdf, xlsx, csv, xls, docx, doc, jpg, png');
                    break;
                default:
                    showPopUp(null, 'Wystąpił błąd',
                        'Wystąpił problem z wybranym plikiem');
            }
        };

        self.pageChanged = function(page) {
            self.currentPage = page;
            fetchUploadedFilesList(page);
        };

        self.downloadFile = function (item) {
            if (self.downloadBusy) return;
            self.downloadBusy = true;
            ZochaFileSharingService.downloadFile(item.id)
                .then(function (success) {
                    if (success && success.data) {
                        var blob = new Blob([success.data]);
                        FileSaver.saveAs(blob, item.name);
                    }
                }, function (error) {
                    console.log('ZochDownloadFile error', error);
                })
                .finally(function () {
                    self.downloadBusy = false;
                });
        };

        function fetchUploadedFilesList(page) {
            ZochaFileSharingService.fetchFilesList(page)
                .then(function (success) {
                    if (success && success.data && success.data.data) self.uploadList = success.data.data;
                    if (success && success.data && success.data.pages) self.numberOfPages = success.data.pages;
                });
        }

        function initPage() {
            $scope.page = 'zoch_upload';
            $scope.$emit('page', $scope.page);
            $scope.step = '';
            $scope.$emit('step', $scope.step);
            $scope.link = 'root.home.zoch.upload';
            $scope.$emit('link', $scope.link);
            fetchUploadedFilesList(self.currentPage);
        }

        function showPopUp(ev, head, content) {
            return $mdDialog.show({
                controller: PopUpInfoCtrl,
                templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-small.html',
                targetEvent: ev,
                clickOutsideToClose: false,
                locals: {
                    head: head,
                    content: content
                }
            });
        }

        function PopUpInfoCtrl($scope, $mdDialog, locals) {
            this.$inject = ['$scope', '$mdDialog', 'locals'];

            $scope.locals = locals;

            $scope.hide = function () {
                $mdDialog.hide();
            };

            $scope.cancel = function () {
                $mdDialog.cancel();
            };

            $scope.confirm = function () {
                $mdDialog.hide($scope.locals);
            };
        }
    }
})();
// @TODO: </HEALTH2019>
